import type { ReactNode } from 'react'
import { BrandMark } from '@/shared/components/brand-mark'

// Brand-icon empty state: ball mark + one-line reason + ONE primary CTA.
export function EmptyState({
  title,
  cta,
  tone = 'mint',
}: {
  title: string
  cta?: ReactNode
  tone?: 'mint' | 'faint'
}) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center px-8 gap-4 py-12">
      <span className={tone === 'mint' ? 'text-[color:var(--brand-mint)]' : 'text-[color:var(--fg-faint)]'}>
        <BrandMark size={72} />
      </span>
      <p className="font-semibold text-[length:var(--fs-lg)] max-w-[17rem]">{title}</p>
      {cta}
    </div>
  )
}
